import { PlantlifeSharedCardData } from './plantlife-shared-card-data';

export class PlantlifeCheapWeedCardData extends PlantlifeSharedCardData {
  constructor() {
    super();
  }
}
